import gql from 'graphql-tag'

export const FACILITY_GRID_QUERY = gql`
  query facilityGrid(
    $accountId: Int!
    $facilityId: Int!
    $page: Int!
    $pageSize: Int!
    $sorts: FacilityGridSortType
    $filters: FacilityGridFilterType
    $search: String
  ) {
    facilityGrid(
      accountId: $accountId
      facilityId: $facilityId
      page: $page
      pageSize: $pageSize
      sorts: $sorts
      filters: $filters
      search: $search
    ) {
      totalPages
      pageSize
      total
      items {
        fixtureId
        fixtureCode
        fixtureType
        fixtureLocation
        leadResult
        remediationAction
        collectedOn
        resultsPerFixture
        leadLevelLimit
        unitOfMeasure
      }
    }
  }
`
